import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BaseControl, ConfirmComponent, Const } from "@app/shared/index";
import { LocalDataSource } from 'ng2-smart-table';
import { InactivateUserFormService } from './shared/inactive-user.form.services';
import { InactivateUserDataService } from './shared/inactive-users-data.services';
import { InactivateUserConfigService } from './shared/inactivate-user-config.service';
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { find } from "lodash";
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { FormGroup } from '@angular/forms';

@Component ({
    selector: 'iw-inactivate-users',
    templateUrl: './inactivate-users.component.html',
    styleUrls: ['./inactivate-users.component.scss'],
    providers: [InactivateUserFormService, InactivateUserDataService, DatePipe],
})
export class InactivateUsersComponent implements OnInit {

  // para poder realizar el filtro general
  source: LocalDataSource;
  sourceModal: LocalDataSource;
  // variable donde se configura las opciones de la tabla
  settings = {};
  // Contiene los controles de el formulario de asociaciones
  controls: BaseControl<any>[] = [];
  controlsModal: BaseControl<any>[] = [];
  // Datos iniciales para la tabla
  // dataTable: Consecutive[] = [];
  // Define los tipos de permisos que tiene el usuario en sesión
  activateAction = {
    created: false,
    update: false,
    delete: false,
    review: false,
    createReason: false,
    updateReason: false,
    deleteReason: false,
  };
  // Referencia a la plantilla para el control personalizado de ng-select
  @ViewChild("ngSelect") ngSelectTpl: TemplateRef<any>;
  //Referencia al modal personalizado
  @ViewChild("modalDetail") modalDetail: any;
  //Referencia al modal de modificar o agregar
  @ViewChild("modalAddModify") modalAddModify: any;
  // Referencia al componente de confirmación
  @ViewChild("confirm") private confirm: ConfirmComponent;
  //modal
  modalRef: BsModalRef;
  // Define cuando mostrar la tabla principal o el formulario
  formOpen = false;
  // Referencia del formulario
  form: FormGroup;

  allUser: any = [];
  allReason: any[] = [];
  inactivationSelected : any;
  userSelected: any = null;
  // Pregunta de la modal de confirmaciones
  question = "";

  constructor(
    private iufs: InactivateUserFormService,
    private iuds: InactivateUserDataService,
    private modal: BsModalService,
    private as: AuthenticationService,
    public datePipe: DatePipe,
    private toastr: ToastrService,
  ) {}

  ngOnInit() {
    // Determina los permisos del usuario en sesion
    this.activateAction.created = this.as.confirmPermission(
      Const.types_permissions.administracionInactivacionUsuarios,
      Const.types_action_permissions.created
    );
    this.activateAction.review = this.as.confirmPermission(
      Const.types_permissions.administracionInactivacionUsuarios,
      Const.types_action_permissions.review
    );
    this.activateAction.update = this.as.confirmPermission(
      Const.types_permissions.administracionInactivacionUsuarios,
      Const.types_action_permissions.update
    );
    this.activateAction.delete = this.as.confirmPermission(
      Const.types_permissions.administracionInactivacionUsuarios,
      Const.types_action_permissions.delete
    );
    this.activateAction.createReason = this.as.confirmPermission(
      Const.types_permissions.administracionInactivacionUsuarios,
      Const.types_action_permissions.createReason
    );
    this.activateAction.updateReason = this.as.confirmPermission(
      Const.types_permissions.administracionInactivacionUsuarios,
      Const.types_action_permissions.updateReason
    );
    this.activateAction.deleteReason = this.as.confirmPermission(
      Const.types_permissions.administracionInactivacionUsuarios,
      Const.types_action_permissions.deleteReason
    );

    //Asignacion de valores y configuracion a la tabla
    const configTable = new InactivateUserConfigService();
    this.settings = configTable.settings;

    configTable.accion.subscribe((res: any) => {
      // log.debug(res.action, res.data);
      this.defineActionCondictions(res.action, res.data);
    });

    this.getUsers();

  }

  /**
   * Obtiene usuarios y motivos 
   */
  async getUsers() {
    this.allUser = [];
    this.allReason = [];
    this.iuds.getAllUsersSystem().subscribe(async users => {
      await users.forEach(dataUser => {
        this.allUser.push({
          value: dataUser.id,
          key: dataUser.identificacion + '-' + dataUser.nombre + ' ' + dataUser.apellido,
        });        
      });
      this.iuds.getAllReason().subscribe(async reasons => {
        await reasons.forEach(dataReason => {
          this.allReason.push({
            value: dataReason.id,
            key: dataReason.nombre
          });
      });
      this.controls = this.iufs.getFormUser(
        this.ngSelectTpl,
        this.allUser,
        this.allReason
      );
      })
    })
  }

  // Abre modal para añadir motivos
  addReason() {
    this.openAddModal();  
  }

  /*
  *Llena la tabla de historial de inactivaciones
  */
  getInactivationsUsers(userId: number){
    let dataHistory: any[] = [];
    this.iuds.getHistoryUsers(userId).then(async res => {
      await res.forEach(data => {
        dataHistory.push({
          id: data.id,
          motivo: data.motivo.nombre,
          fecha_inicial: this.datePipe.transform(data.fecha_inicial, 'dd-MM-yyyy'),
          fecha_final: this.datePipe.transform(data.fecha_final, 'dd-MM-yyyy')
        })
      })
      this.source = new LocalDataSource(dataHistory);
      this.source.refresh();
    })
  }

  openAddModal() {
    this.modalRef = this.modal.show(this.modalAddModify, { class: "modal-lg-personalized", ignoreBackdropClick: true });
    this.controlsModal = this.iufs.getReason();
  }

  // Cierra modal
  closeModalAddModify() {
    this.formOpen = false;
    this.modalRef.hide();
  }

  saveReason(data: any){
    let motivo = {
      nombre: data.motivo
    }
    this.iuds.addReasonInactivation(motivo).then(async resp => {
      if(resp) {
        let newReason: any = await find(this.controls, { key: 'motivo'});
        this.iuds.getAllReason().subscribe(async reasons => {
          this.allReason = [];
          await reasons.forEach(dataReason => {
            this.allReason.push({
              value: dataReason.id,
              key: dataReason.nombre
            });
        });
        if(newReason){
          newReason.options = this.allReason;
        }
        })
        this.closeModalAddModify();
      }
    })
  }

  /*
  *Funcion para inactivar usuarios
  */
  inactivarUsuario(data: any){
    let inactivation = {
      usuario: data.funcionario,
      motivo: data.motivo,
      fecha_inicial: this.datePipe.transform(data.fecha_inicial, 'yyyy-MM-dd'),
      fecha_final: this.datePipe.transform(data.fecha_final, 'yyyy-MM-dd'),
    }
    if(this.activateAction.created){      
      this.iuds.addUserInactivation(inactivation).then(async resp => {
        if(resp){
          let dateOne: any = await find(this.controls, { key: 'fecha_inicial'});
          let dateTwo: any = await find(this.controls, { key: 'fecha_final'});
          if(dateOne && dateTwo){
            dateOne.value = null;
            dateTwo.value = null;
          }
          this.getInactivationsUsers(data.funcionario);
        }
      })
    } else {
      this.toastr.warning('Usted no posee permisos para inactivar usuarios',
            'Permiso denegado');
    }
  }

  selecteUser(data: any) {
    if(data.controlChanged == 'funcionario' && data.change.funcionario){
      this.userSelected = data.change.funcionario;
      this.getInactivationsUsers(data.change.funcionario);
    }
  }

  actionComfirm(res: boolean) {
    if (res) {
      this.deleteInactivation(this.inactivationSelected);
    }
  }

  defineActionCondictions(action: "add" | "update" | "detail" | "delete" = "add", data?: any) {
    switch (action) {
      case 'delete':
        if (this.activateAction.delete) {
          this.inactivationSelected = data;
          this.question = '¿Realmente desea eliminar la inactivación?';
          this.confirm.open();
        } else {
          this.toastr.warning('Usted no posee permisos para eliminar la inactivación',
            'Permiso denegado');
        }
        break;
    }
  }

  deleteInactivation(data: any){
    this.iuds.deleteUserInactivation(data.id).then(async resp => {
      if(resp){
        await this.getInactivationsUsers(this.userSelected);
      }
    });
  }
  
}


// WEBPACK FOOTER //
// ./src/app/administration/system-users-inactivation/inactivate-users/inactivate-users.component.ts